/* eslint-disable sonarjs/cognitive-complexity, react/prop-types */
/*
 * ApproveApplicationPopUp]jsx
 * Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
 * All rights reserved.
 */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Stack,
  Typography,
  TextField,
  Button,
  FormControl,
  OutlinedInput,
  Box,
  Chip,
  ListItemText,
  Tooltip,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";
import { FileUploader } from "react-drag-drop-files";
import APIManager from "../../Services/ApiManager/ApiManager";
import PopupDialog from "../PopupDialog";
import {
  patchPortfolioAppApproveRejectDetails,
  postSubmissionDetailsDomainApprover,
  patchDomainApproverAppApproveRejectDetails,
  postSubmissionDetailsDomainApproverForProduction,
} from "../../Services/redux/Application-details/ApplicationDetailsActions";
import "./ApproveApplicationPopUp.css";
import { getConfig } from "../../config";

function ApproveApplicationPopUp({
  handlePopupModalClose,
  nextReviewStatus,
  submissionData,
}) {

  const [componentName, setComponentName] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [headerMessage, setHeaderMessage] = useState("");
  const { submissionId, appId } = useParams();
  const navigate = useNavigate();
  const [reportLink, setReportLink] = useState("");
  const [reportComment, setReportComment] = useState("");
  const [errorReportLink, setErrorReportLink] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [fileName, setFileName] = useState("");
  const [reviewStatus] = useState(nextReviewStatus);
  const [forceInstall, setForceInstall] = useState(false);
  const [forceUninstallReasonValue, setForceUninstallReasonValue] = useState(0);
  const [selectedVehicleLists, setSelectedVehicleLists] = useState([]);
  const [originallyAssociatedGroups, setOriginallyAssociatedGroups] = useState(
    []
  );
  const [vehicleLists, setVehicleLists] = useState([]);
  const [loadingVehicleLists, setLoadingVehicleLists] = useState(false);
  const [associationError, setAssociationError] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDSACheckbox, setShowDSACheckbox] = useState(false);
  const [dsaCompliant, setDsaCompliant] = useState(false);
  const [europeanCountries, setEuropeanCountries] = useState(false);
  const [newTags, setNewTags]=useState([])
  const dispatch = useDispatch();
  const isEuropeanCountry = useSelector((state)=> state.DSAOemAdminReducer.isEuropeanCountry);
  const checkTagCountries = useSelector((state)=> state.DSAOemAdminReducer.checkTagCountries);
  const updatedTargetingTags = useSelector((state)=> state.DSAOemAdminReducer.updatedTargetingTags);
  const fileTypes =
    getConfig().REACT_APP_PORTAL === "domain-approver" ||
    getConfig().REACT_APP_PORTAL === "global-admin"
      ? ["pdf", "txt", "zip"]
      : ["docx", "pdf", "zip", "doc", "txt"];

  useEffect(()=>{
 
  if(getConfig().REACT_APP_PORTAL==="oem-admin" && submissionData?.tags?.length > 0){
     const contentCountryTag = submissionData.tags.find(tag => tag.key === "country");
     const countryValues = [
       ...(contentCountryTag?.values || [])
     ];
     const hasDsa = countryValues.some(code => getConfig().CHECK_EUROPEAN_COUNTRIES.includes(code));
     console.log(hasDsa);
     setShowDSACheckbox(hasDsa);
  } else if (getConfig().REACT_APP_PORTAL === "global-admin" && submissionData?.targeting) {
    const reactEuropeanCountries = getConfig().REACT_APP_EUROPEAN_COUNTRIES;
    let checkEurope = false;
    
    if (submissionData.targeting.countriesInclusions?.length > 0 && reactEuropeanCountries?.length > 0) {
      for (const countryCode of submissionData.targeting.countriesInclusions) {
        if (reactEuropeanCountries.includes(countryCode)) {
          checkEurope = true;
          break;
        }
      }
    }
    
    setEuropeanCountries(checkEurope);
   
  }
  },[]) 


  useEffect(() => {
if(getConfig().REACT_APP_PORTAL==="oem-admin" && submissionData?.tags){
  // If full updated tags are available from targeting saves, use them
  if(updatedTargetingTags && updatedTargetingTags.length > 0){
    setNewTags([...updatedTargetingTags]);
  } else if(checkTagCountries && checkTagCountries.length > 0){
    let tags=[...submissionData.tags];
    const countryTagIndex = tags.findIndex(tag => tag.key === "country");
      if(countryTagIndex !== -1){
        tags[countryTagIndex] = { ...tags[countryTagIndex], values: checkTagCountries };
        setNewTags(tags);
      }
    }
  }

  }, [checkTagCountries, updatedTargetingTags]);

   const scrollableBoxStyle =
    showDSACheckbox && nextReviewStatus === "APPROVED_FOR_CLOSED_BETA"
      ? {
          maxHeight: "420px",
          overflowY: "auto",
          paddingRight: "8px",
        }
      : {};

  useEffect(() => {
    if(isEuropeanCountry){
      setShowDSACheckbox(true);
    }else{
      setShowDSACheckbox(false);
    }
   }, [isEuropeanCountry]);

  const handleReportLinkChange = ($event) => {
    const value = $event.target.value;
    setReportLink(value);

    // Clear error when user starts typing
    if (errorReportLink && value.trim() === "") {
      setErrorReportLink(false);
    }
  };
  // Add URL validation function
  const isValidUrl = (string) => {
    return string.startsWith("https://") && URL.canParse(string);
  };

  // Update the getReportUrl function
  const getReportUrl = () => {
    if (reportLink && reportLink.trim() !== "") {
      if (isValidUrl(reportLink)) {
        setErrorReportLink(false);
      } else {
        setErrorReportLink(true);
      }
    } else {
      setErrorReportLink(false);
    }
  };
  const listedReasons = [
    "App was removed due to a violation of store policy.",
    "App was removed due to a performance related issue.",
    "App was removed due to a security related issue.",
  ];

  // Fetch vehicle lists from API when dropdown is opened
  const fetchVehicleLists = async () => {
    if (nextReviewStatus === "APPROVED_FOR_CLOSED_BETA") {
      setLoadingVehicleLists(true);
      try {
        const portfolioId = sessionStorage.getItem("portfolioId");
        const packageId =
          submissionData?.packageId || sessionStorage.getItem("contentId");

        if (portfolioId) {
          // First, fetch the vehicle lists
          const response = await APIManager.getVehicleLists(portfolioId);

          // Handle different possible response structures
          let vehicleData = [];
          if (response?.data) {
            vehicleData = Array.isArray(response.data) ? response.data : [];
          } else if (response && Array.isArray(response)) {
            vehicleData = response;
          }

          if (vehicleData.length > 0) {
            // Map the response to extract group names
            const groups = vehicleData.map((group, index) => ({
              id: group.id || group.groupId || index,
              name:
                group.groupName ||
                group.name ||
                group.title ||
                `Vehicle List ${index + 1}`,
            }));

            // Sort the groups alphabetically by name
            const sortedGroups = groups.sort((a, b) =>
              a.name.localeCompare(b.name)
            );
            setVehicleLists(sortedGroups);

            // Now check if there are groups already associated with this package
            if (packageId) {
              try {
                const associatedGroupsResponse =
                  await APIManager.getGroupsForApplication(
                    portfolioId,
                    packageId
                  );

                // Handle different possible response structures for associated groups
                let associatedGroups = [];
                if (associatedGroupsResponse?.data) {
                  associatedGroups = Array.isArray(
                    associatedGroupsResponse.data
                  )
                    ? associatedGroupsResponse.data
                    : [];
                } else if (
                  associatedGroupsResponse &&
                  Array.isArray(associatedGroupsResponse)
                ) {
                  associatedGroups = associatedGroupsResponse;
                }

                // Extract the names of already associated groups and pre-select them
                if (associatedGroups.length > 0) {
                  const associatedGroupNames = associatedGroups
                    .map(
                      (group) =>
                        group.groupName || group.name || group.title || ""
                    )
                    .filter((name) => name !== "");

                  // Store the original associations for comparison later
                  setOriginallyAssociatedGroups([...associatedGroupNames]);

                  // Set the selected vehicle lists to the already associated groups
                  setSelectedVehicleLists(associatedGroupNames);
                }
              } catch (associatedError) {
                console.error(
                  "Error fetching associated groups:",
                  associatedError
                );
                // Don't throw error here, just log it as this is additional functionality
              }
            }
          } else {
            setVehicleLists([]);
          }
        }
      } catch (error) {
        console.error("Error fetching vehicle lists:", error);
        setVehicleLists([]);
      } finally {
        setLoadingVehicleLists(false);
      }
    }
  };

  const handleVehicleListChange = (event) => {
    const value = event.target.value;

    // Clear any previous association errors when user changes selection
    setAssociationError("");

    // Check if "Select All" was clicked
    if (value.includes("select-all")) {
      // If "Select All" is in the selection, toggle all
      if (selectedVehicleLists.length === vehicleLists.length) {
        // If all are selected, deselect all
        setSelectedVehicleLists([]);
      } else {
        // If not all are selected, select all
        setSelectedVehicleLists(vehicleLists.map((group) => group.name));
      }
    } else {
      // Normal selection handling
      setSelectedVehicleLists(
        typeof value === "string" ? value.split(",") : value
      );
    }
  };

  const deleteFile = () => {
    setFileData(null);
    setFileName("");
  };

  const handleForceInstallAll = ($event) => {
    setForceInstall($event.target.checked);
  };

  const handleChangeReasonForceUninstall = ($event) => {
    setForceUninstallReasonValue($event.target.value);
  };

  const validateUrlAndComment = () => {
    const hasValidComment =
      reportComment && reportComment.trim() !== "" && reportComment !== null;
    const hasFile = fileData !== null;
    const hasValidUrl =
      reportLink && reportLink.trim() !== "" && isValidUrl(reportLink);
    const hasSelectedVehicleLists = selectedVehicleLists.length > 0;
    const hasDSAComplianceOemAdmin = showDSACheckbox && dsaCompliant;
    const hasDSAComplianceGlobalAdmin = europeanCountries && dsaCompliant;

    if (
      nextReviewStatus === "PRODUCTION_APPROVAL_APPROVED" ||
      nextReviewStatus === "STAGING_APPROVAL_APPROVED"
    ) {
      return showDSACheckbox ? hasValidComment && (hasFile || hasValidUrl) &&  hasDSAComplianceOemAdmin : hasValidComment && (hasFile || hasValidUrl);
    } else if (nextReviewStatus === "APPROVED_FOR_CLOSED_BETA") {
      return showDSACheckbox ? hasValidComment && hasSelectedVehicleLists && hasDSAComplianceOemAdmin : hasValidComment && hasSelectedVehicleLists;
    } else if (nextReviewStatus === "DELIST_AT_PRODUCTION") {
      return hasValidComment;
    } else if (
      nextReviewStatus === "approve_staging" ||
      nextReviewStatus === "approve_production" ||
      nextReviewStatus === "DOMAIN_APPROVAL_APPROVED" ||
      nextReviewStatus === "reject_staging" ||
      nextReviewStatus === "reject_production"
    ) {
      if (nextReviewStatus === "approve_production" && europeanCountries && getConfig().REACT_APP_PORTAL==="global-admin") {
        return (hasFile || hasValidUrl) && hasDSAComplianceGlobalAdmin;
      }
      return hasFile || hasValidUrl;
    }

    return hasValidComment;
  };
  const isNotActive = !validateUrlAndComment() || errorReportLink;

  const sendApproveOrReject = async () => {
    // ✅ Helper function to determine navigation behavior based on current context
    const getNavigationConfig = () => {
      const currentTab = sessionStorage.getItem("domain-approver-selectedTab");
      const currentStatus = sessionStorage.getItem(
        "domain-approver-activeStatus"
      );

      if (currentTab === "1") {
        // From 3rd Party Apps → Navigate to Group Apps with default status
        return {
          shouldPersistStatus: false,
          targetStatus: "SUBMITTED_FOR_PRODUCTION",
        };
      } else {
        // From Group Apps → Persist current status
        return {
          shouldPersistStatus: true,
          targetStatus: currentStatus || "SUBMITTED_FOR_PRODUCTION",
        };
      }
    };

    const navigationConfig = getNavigationConfig();
    const formData = new FormData();
    if (getConfig().REACT_APP_PORTAL === "oem-admin") {
      if (
        nextReviewStatus === "PRODUCTION_APPROVAL_APPROVED" ||
        nextReviewStatus === "STAGING_APPROVAL_APPROVED"
      ) {
        formData.append("tags", newTags && newTags.length > 0 ? JSON.stringify(newTags) : JSON.stringify(submissionData.tags));
        formData.append("reviewStatus", nextReviewStatus);
        formData.append("reasonForCounrtyExclusion", "");
        formData.append("reviewComments", reportComment);
        if (fileData === null) {
          formData.append("link", reportLink);
        } else {
          formData.append("file", fileData);
        }
        if(showDSACheckbox){
          formData.append("isDSACompliant", dsaCompliant);
        }
        formData.append("portfolioContentModes", JSON.stringify([]));
        if (submissionData.isClosedBeta === true) {
          formData.append("isClosedBeta", false);
        }
      } else if (
        nextReviewStatus === "PRODUCTION_APPROVAL_IN_REVIEW" ||
        nextReviewStatus === "STAGING_APPROVAL_IN_REVIEW"
      ) {
         formData.append("tags", newTags && newTags.length > 0 ? JSON.stringify(newTags) : JSON.stringify(submissionData.tags));
        formData.append("reasonForCounrtyExclusion", "");
        formData.append("reviewComments", reportComment);
        if (fileData === null) {
          formData.append("link", reportLink);
        } else {
          formData.append("file", fileData);
        }
        formData.append("portfolioContentModes", JSON.stringify([]));
        if (submissionData.isClosedBeta === true) {
          formData.append("isClosedBeta", false);
        }
      } else if (nextReviewStatus === "APPROVED_FOR_CLOSED_BETA") {
        // Handle vehicle group associations/disassociations
        let successfulRemovals = [];
        let successfulAdditions = [];

        if (
          selectedVehicleLists.length > 0 ||
          originallyAssociatedGroups.length > 0
        ) {
          const portfolioId = sessionStorage.getItem("portfolioId");
          const packageId =
            submissionData?.packageId || sessionStorage.getItem("contentId");

          // Detect changes between original and current selections
          const groupsToAdd = selectedVehicleLists.filter(
            (group) => !originallyAssociatedGroups.includes(group)
          );
          const groupsToRemove = originallyAssociatedGroups.filter(
            (group) => !selectedVehicleLists.includes(group)
          );

          let allOperationsSuccessful = true;
          let errorMessages = [];

          // Handle group removals first
          if (groupsToRemove.length > 0) {
            const groupsToRemoveIds = groupsToRemove
              .map((groupName) => {
                const vehicleList = vehicleLists.find(
                  (group) => group.name === groupName
                );
                return vehicleList ? vehicleList.id : null;
              })
              .filter((id) => id !== null);

            const removalResults = await Promise.allSettled(
              groupsToRemoveIds.map((groupId) =>
                APIManager.deleteGroupFromApplication(
                  portfolioId,
                  groupId,
                  packageId
                )
              )
            );

            // Track successful removals for potential rollback
            removalResults.forEach((result, index) => {
              if (result.status === "fulfilled") {
                successfulRemovals.push(groupsToRemoveIds[index]);
              }
            });

            const failedRemovals = removalResults.filter(
              (result) => result.status === "rejected"
            );
            if (failedRemovals.length > 0) {
              allOperationsSuccessful = false;
              errorMessages.push(
                `Failed to remove ${failedRemovals.length} out of ${groupsToRemove.length} vehicle groups.`
              );
            }
          }

          // Handle group additions
          if (groupsToAdd.length > 0) {
            const groupsToAddIds = groupsToAdd
              .map((groupName) => {
                const vehicleList = vehicleLists.find(
                  (group) => group.name === groupName
                );
                return vehicleList ? vehicleList.id : null;
              })
              .filter((id) => id !== null);

            const additionResults = await Promise.allSettled(
              groupsToAddIds.map((groupId) =>
                APIManager.associateGroupWithApplication(
                  portfolioId,
                  packageId,
                  { id: groupId }
                )
              )
            );

            // Track successful additions for potential rollback
            additionResults.forEach((result, index) => {
              if (result.status === "fulfilled") {
                successfulAdditions.push(groupsToAddIds[index]);
              }
            });

            const failedAdditions = additionResults.filter(
              (result) => result.status === "rejected"
            );
            if (failedAdditions.length > 0) {
              allOperationsSuccessful = false;
              errorMessages.push(
                `Failed to add ${failedAdditions.length} out of ${groupsToAdd.length} vehicle groups.`
              );
            }
          }

          // Handle errors
          if (!allOperationsSuccessful) {
            setAssociationError(errorMessages.join(" "));
          }

          // If we have selected groups but all operations failed, don't proceed
          if (
            selectedVehicleLists.length > 0 &&
            groupsToAdd.length > 0 &&
            groupsToAdd.every((groupName) => {
              const vehicleList = vehicleLists.find(
                (group) => group.name === groupName
              );
              return !vehicleList; // If we can't find the vehicle list, consider it failed
            })
          ) {
            setAssociationError(
              "Failed to associate any vehicle lists with the application. Please try again."
            );
            return;
          }
        }

        setIsSubmitting(true);

        try {
          formData.append("tags", newTags && newTags.length > 0 ? JSON.stringify(newTags) : JSON.stringify(submissionData.tags));
          formData.append("reasonForCounrtyExclusion", "");
          formData.append("reviewStatus", submissionData.reviewStatus);
          formData.append("isClosedBeta", true);
          if(showDSACheckbox){
          formData.append("isDSACompliant", showDSACheckbox);
          }
          formData.append("reviewComments", reportComment);
          if (fileData === null) {
            formData.append("link", reportLink);
          } else {
            formData.append("file", fileData);
          }
          formData.append("portfolioContentModes", []);

          const portfolioId = sessionStorage.getItem("portfolioId");
          const contentId = sessionStorage.getItem("contentId");

          await APIManager.approvAndRejectApps(
            portfolioId,
            contentId,
            formData
          );

          // Show success message
          setSnackbarMessage(
            "Application approved for closed beta successfully!"
          );
          setSnackbarSeverity("success");
          setSnackbarOpen(true);

          setTimeout(() => {
            handlePopupModalClose();
            navigate("/ui/oem-admin/applications");
          }, 2000);
        } catch (error) {
          console.error("Error approving closed beta:", error);
          try {
            const portfolioId = sessionStorage.getItem("portfolioId");
            const packageId =
              submissionData?.packageId || sessionStorage.getItem("contentId");

            if (successfulAdditions.length > 0) {
              await Promise.allSettled(
                successfulAdditions.map((groupId) =>
                  APIManager.deleteGroupFromApplication(
                    portfolioId,
                    groupId,
                    packageId
                  )
                )
              );
            }

            if (successfulRemovals.length > 0) {
              await Promise.allSettled(
                successfulRemovals.map((groupId) =>
                  APIManager.associateGroupWithApplication(
                    portfolioId,
                    packageId,
                    { id: groupId }
                  )
                )
              );
            }

            setSnackbarMessage(
              "Failed to approve application for closed beta. Vehicle group associations have been reverted. Please try again."
            );
          } catch (rollbackError) {
            console.error("Error during rollback:", rollbackError);
            setSnackbarMessage(
              "Failed to approve application for closed beta and encountered an error while reverting changes. Please verify vehicle group associations manually."
            );
          }

          setSnackbarSeverity("error");
          setSnackbarOpen(true);

          setTimeout(() => {
            handlePopupModalClose();
            navigate("/ui/oem-admin/applications");
          }, 3000);
        } finally {
          setIsSubmitting(false);
        }

        return;
      } else if (
        nextReviewStatus === "DELIST_AT_PRODUCTION" ||
        nextReviewStatus === "DELIST_AT_STAGING"
      ) {
        if (forceInstall) {
           formData.append("tags", newTags && newTags.length > 0 ? JSON.stringify(newTags) : JSON.stringify(submissionData.tags));
          formData.append(
            "reviewStatus",
            nextReviewStatus === "DELIST_AT_PRODUCTION"
              ? "FORCE_UNINSTALL_AT_PRODUCTION"
              : "FORCE_UNINSTALL_AT_STAGING"
          );
          formData.append("reasonForCounrtyExclusion", "");
          if (forceUninstallReasonValue === 0) {
            formData.append("reviewComments", "VIOLATION");
          } else if (forceUninstallReasonValue === 1) {
            formData.append("reviewComments", "PERFORMANCE");
          } else {
            formData.append("reviewComments", "SECURITY");
          }
          formData.append("portfolioContentModes", JSON.stringify([]));
        } else {
           formData.append("tags", newTags && newTags.length > 0 ? JSON.stringify(newTags) : JSON.stringify(submissionData.tags));
          formData.append("reviewStatus", nextReviewStatus);
          formData.append("reasonForCounrtyExclusion", "");
          formData.append("reviewComments", reportComment);
          formData.append("portfolioContentModes", JSON.stringify([]));
        }
      } else {
         formData.append("tags", newTags && newTags.length > 0 ? JSON.stringify(newTags) : JSON.stringify(submissionData.tags));
        formData.append("reviewStatus", nextReviewStatus);
        formData.append("reasonForCounrtyExclusion", "");
        formData.append("reviewComments", reportComment);
        formData.append("portfolioContentModes", JSON.stringify([]));
        if (
          (nextReviewStatus === "REJECTED_AT_PRODUCTION" ||
            nextReviewStatus === "REJECTED_AT_STAGING") &&
          submissionData.isClosedBeta === true
        ) {
          formData.append("isClosedBeta", false);
        }
      }

      handlePopupModalClose();
      
      // Wait for the action to complete before navigating
      await Promise.resolve(
        dispatch(
          patchPortfolioAppApproveRejectDetails(
            sessionStorage.getItem("portfolioId"),
            sessionStorage.getItem("contentId"),
            formData
          )
        )
      );
      
      // Navigate with refresh state
      navigate("/ui/oem-admin/applications", {
        state: { refresh: Date.now() }
      });
    }
    if (getConfig().REACT_APP_PORTAL === "domain-approver") {
      const obj = {};
      if (fileData !== null) {
        obj["file"] = fileData;
      } else if (reportLink && reportLink.trim() !== "") {
        obj["link"] = reportLink;
      }
      try {
        if (
          nextReviewStatus === "approve_staging" ||
          nextReviewStatus === "reject_staging"
        ) {
          await Promise.resolve(dispatch(
            postSubmissionDetailsDomainApprover(
              appId,
              submissionId,
              nextReviewStatus,
              fileData,
              reportComment,
              reportLink
            )
          ));
        } else if (
          nextReviewStatus === "approve_production" ||
          nextReviewStatus === "reject_production"
        ) {
          await Promise.resolve(dispatch(
            postSubmissionDetailsDomainApproverForProduction(
              appId,
              submissionId,
              nextReviewStatus,
              fileData,
              reportComment,
              reportLink
            )
          ));
        } else if (
          nextReviewStatus === "REJECTED_BY_DOMAIN_APPROVER" ||
          nextReviewStatus === "DOMAIN_APPROVAL_IN_REVIEW"
        ) {
          obj["domainApprovalStatus"] = nextReviewStatus;
          obj["domainApproverComments"] = reportComment;
          await Promise.resolve(dispatch(
            patchDomainApproverAppApproveRejectDetails(appId, obj)
          ));
          handlePopupModalClose();
          sessionStorage.setItem("domain-approver-selectedTab", "0");
          sessionStorage.setItem(
            "domain-approver-activeStatus",
            navigationConfig.targetStatus
          );
          navigate("/ui/domain-approver/applications", {
            replace: true,
            state: {
              refresh: Date.now(),
              selectedTab: 0,
              fromContext: navigationConfig.shouldPersistStatus
                ? "groupApps"
                : "thirdPartyApps",
            },
          });
        } else if (nextReviewStatus === "DOMAIN_APPROVAL_APPROVED") {
          obj["domainApprovalStatus"] = nextReviewStatus;
          obj["domainApproverComments"] = reportComment;
          if (fileData !== null) {
            obj["file"] = fileData;
          }
          if (reportLink && reportLink.trim() !== "") {
            obj["link"] = reportLink;
          }
          await Promise.resolve(dispatch(
            patchDomainApproverAppApproveRejectDetails(appId, obj)
          ));
          handlePopupModalClose();
          sessionStorage.setItem("domain-approver-selectedTab", "0");
          sessionStorage.setItem(
            "domain-approver-activeStatus",
            navigationConfig.targetStatus
          );
          navigate("/ui/domain-approver/applications", {
            replace: true,
            state: {
              refresh: Date.now(),
              selectedTab: 0,
              fromContext: navigationConfig.shouldPersistStatus
                ? "groupApps"
                : "thirdPartyApps",
            },
          });
        }
      } catch (error) {
        console.error("Error occurred:", error);
      } finally {
        handlePopupModalClose();
        sessionStorage.setItem("domain-approver-selectedTab", "0");
        sessionStorage.setItem(
          "domain-approver-activeStatus",
          navigationConfig.targetStatus
        );
        navigate("/ui/domain-approver/applications", {
          replace: true,
          state: {
            refresh: Date.now(),
            selectedTab: 0,
            fromContext: navigationConfig.shouldPersistStatus
              ? "groupApps"
              : "thirdPartyApps",
          },
        });
      }
    } else if (getConfig().REACT_APP_PORTAL === "global-admin") {
      const obj = {};
      if (fileData !== null) {
        obj["file"] = fileData;
      }
      if (
        nextReviewStatus === "approve_production" ||
        nextReviewStatus === "reject_production"
      ) {
        try {
          await APIManager.postSubmissionDetailsDomainApproverForProduction(
            appId,
            submissionId,
            nextReviewStatus,
            fileData,
            reportComment
          );
          handlePopupModalClose();
          navigate("/ui/harman-admin/applications");
        } catch (error) {
          console.error("Error fetching data:", error);
          setComponentName("appError");
          setErrorMessage(error.message);
          setHeaderMessage(
            error.message === "jwt expired" ? "401 Token Expired" : "Error"
          );
          setOpenErrorPopup(true);
          return;
        }
      }
    }
  };

   const handleFileChange = (file) => {
    
if (file?.size === 0) {
    setSnackbarMessage("File is empty. Please upload a file larger than 0 KB.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return;
  }
  // Check for invalid characters in filename (allow alphanumeric, dots, hyphens, underscores)
  const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
  const filenameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
  
  if (!validFilenamePattern.test(filenameWithoutExtension)) {
    setSnackbarMessage("File name should only contain alphanumeric characters, dots, hyphens, and underscores.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return;
  }
  
  setFileName(file.name);
  setFileData(file);
};
  

  const handleFileTypeError = (err) => {
    if (
      getConfig().REACT_APP_PORTAL === "domain-approver" ||
      getConfig().REACT_APP_PORTAL === "global-admin"
    ) {
      setSnackbarMessage("Only PDF, TXT, and ZIP files are allowed.");
    } else {
      setSnackbarMessage(
        "Only PDF, DOC, DOCX, TXT, and ZIP files are allowed."
      );
    }
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  };

  const handleReportComment = ($event) => {
    setReportComment($event.target.value);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getVehicleListOptions = () => {
    if (loadingVehicleLists) {
      return [
        <MenuItem key="loading" disabled>
          <em>Loading...</em>
        </MenuItem>,
      ];
    }
    if (vehicleLists.length === 0) {
      return [
        <MenuItem key="empty" disabled>
          <em>No vehicle lists available</em>
        </MenuItem>,
      ];
    }
    return [
      <MenuItem key="select-all" value="select-all">
        <Checkbox
          checked={
            selectedVehicleLists.length === vehicleLists.length &&
            vehicleLists.length > 0
          }
          indeterminate={
            selectedVehicleLists.length > 0 &&
            selectedVehicleLists.length < vehicleLists.length
          }
          sx={{
            padding: "4px 8px 4px 4px",
            "&.Mui-checked": {
              color: "#1976d2",
            },
            "&.MuiCheckbox-indeterminate": {
              color: "#1976d2",
            },
          }}
        />
        <ListItemText
          primary={
            selectedVehicleLists.length === vehicleLists.length &&
            vehicleLists.length > 0
              ? "Deselect All"
              : "Select All"
          }
          sx={{
            "& .MuiListItemText-primary": {
              fontSize: "14px",
              fontWeight: "600",
              color: "#1976d2",
            },
          }}
        />
      </MenuItem>,
      <MenuItem
        key="divider"
        disabled
        sx={{
          borderBottom: "1px solid #e0e0e0",
          padding: "0px",
          minHeight: "1px",
        }}
      ></MenuItem>,
      ...vehicleLists.map((group) => (
        <MenuItem key={group.id} value={group.name}>
          <Checkbox
            checked={selectedVehicleLists.includes(group.name)}
            sx={{
              padding: "4px 8px 4px 4px",
              "&.Mui-checked": {
                color: "#1976d2",
              },
            }}
          />
          <ListItemText
            primary={group.name}
            sx={{
              "& .MuiListItemText-primary": {
                fontSize: "14px",
              },
            }}
          />
        </MenuItem>
      )),
    ];
  };

  return (
    <div>
      <div
        style={{ display: "flex", flexDirection: "column", marginLeft: "15px", ...scrollableBoxStyle }}
      >
        {nextReviewStatus === "APPROVED_FOR_CLOSED_BETA" && (
          <div style={{ marginBottom: "20px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "16px",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                  verticalAlign: "middle",
                  color: "#2A2C2D",
                  marginRight: "8px",
                }}
              >
                Vehicle List
              </Typography>
              <Tooltip
                title="Select a vehicle list from the dropdown below or Add a new vehicle list using the (+) plus button."
                placement="right"
                arrow
                slotProps={{
                  tooltip: {
                    sx: {
                      maxWidth: 180,
                      fontSize: "12px",
                    },
                  },
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 16,
                    color: "#A3A3A3",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FormControl fullWidth>
                <Select
                  multiple
                  value={selectedVehicleLists}
                  onChange={handleVehicleListChange}
                  onOpen={fetchVehicleLists}
                  input={<OutlinedInput />}
                  renderValue={(selected) =>
                    selected.length === 0 ? (
                      <span style={{ color: "rgba(0, 0, 0, 0.6)" }}>
                        Select at least one from vehicle list
                      </span>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 0.5,
                          maxHeight: "32px",
                          overflowY: "hidden",
                          alignItems: "center",
                          paddingRight: "8px",
                          paddingBottom: "4px",
                          paddingTop: "2px",
                        }}
                      >
                        {/* Show first two items as chips */}
                        {selected.slice(0, 2).map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            size="small"
                            sx={{
                              height: "20px",
                              fontSize: "11px",
                              maxWidth: "120px",
                              "& .MuiChip-label": {
                                paddingLeft: "6px",
                                paddingRight: "6px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              },
                            }}
                          />
                        ))}
                        {/* Show "+ X more" if there are more than 2 selections */}
                        {selected.length > 2 && (
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              fontWeight: "500",
                              marginLeft: "4px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            + {selected.length - 2} more
                          </span>
                        )}
                      </Box>
                    )
                  }
                  displayEmpty
                  sx={{
                    "& .MuiSelect-select": {
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      minHeight: "24px",
                      maxHeight: "48px",
                      overflowY: "auto",
                    },
                  }}
                >
                  {getVehicleListOptions()}
                </Select>
              </FormControl>
              <div style={{ position: "relative" }}>
                <Tooltip
                  title="You can add Vehicle list from here"
                  placement="top"
                  arrow
                  slotProps={{
                    tooltip: {
                      sx: {
                        maxWidth: 150,
                        fontSize: "12px",
                      },
                    },
                  }}
                >
                  <AddIcon
                    onClick={() =>
                      window.open("/ui/oem-admin/closed-beta", "_blank")
                    }
                    sx={{
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "4px",
                      padding: "6px",
                      cursor: "pointer",
                      height: "22px",
                      width: "22px",
                      display: "flex",
                      alignItems: "center",
                      color: "#717273",
                      justifyContent: "center",
                      "&:hover": {
                        borderColor: "rgba(0, 0, 0, 0.87)",
                      },
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        )}
        {associationError && (
          <Box
            sx={{
              marginTop: 2,
              marginBottom: 2,
              padding: 2,
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeaa7",
              borderRadius: "4px",
              marginLeft: "15px",
              marginRight: "15px",
            }}
          >
            <Typography
              sx={{
                color: "#856404",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              {associationError}
            </Typography>
          </Box>
        )}
        {reviewStatus !== "REJECTED_AT_PRODUCTION" &&
          reviewStatus !== "REJECTED_AT_STAGING" &&
          reviewStatus !== "DELIST_AT_PRODUCTION" &&
          reviewStatus !== "DELIST_AT_STAGING" &&
          reviewStatus !== "REJECTED_BY_DOMAIN_APPROVER" &&
          reviewStatus !== "DOMAIN_APPROVAL_IN_REVIEW" &&
          reviewStatus !== "reject_staging" &&
          reviewStatus !== "reject_production" && (
            <Typography
              sx={{
                // fontFamily: "Roboto",
                fontWeight: "600",
                fontSize: "16px",
                lineHeight: "100%",
                letterSpacing: "0px",
                verticalAlign: "middle",
                color: "#2A2C2D",
              }}
            >
              Upload Report
              {getConfig().REACT_APP_PORTAL === "global-admin" && (
                <span style={{ color: "red" }}> *</span>
              )}
            </Typography>
          )}

        {(reviewStatus === "reject_staging" ||
          reviewStatus === "reject_production") && (
          <Typography
            sx={{
              // fontFamily: "Roboto",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "100%",
              letterSpacing: "0px",
              verticalAlign: "middle",
              color: "#2A2C2D",
            }}
          >
            Upload Report <span style={{ color: "red" }}>*</span>
          </Typography>
        )}
        {reviewStatus !== "REJECTED_AT_PRODUCTION" &&
          reviewStatus !== "REJECTED_AT_STAGING" &&
          reviewStatus !== "DELIST_AT_PRODUCTION" &&
          reviewStatus !== "DELIST_AT_STAGING" &&
          reviewStatus !== "REJECTED_BY_DOMAIN_APPROVER" &&
          reviewStatus !== "DOMAIN_APPROVAL_IN_REVIEW" &&
          (getConfig().REACT_APP_PORTAL === "domain-approver" ||
          getConfig().REACT_APP_PORTAL === "global-admin" ? (
            <Typography
              sx={{
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "140%",
                letterSpacing: "0px",
                verticalAlign: "middle",
                color: "#5A5B5C",
                marginTop: "10px",
              }}
            >
              Report must be pdf, txt, or zip file.
            </Typography>
          ) : (
            <Typography
              sx={{
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "140%",
                letterSpacing: "0px",
                verticalAlign: "middle",
                color: "#5A5B5C",
                marginTop: "10px",
              }}
            >
              Report must be pdf, doc, docx, txt, or zip file.
            </Typography>
          ))}
        {reviewStatus !== "REJECTED_AT_PRODUCTION" &&
          reviewStatus !== "REJECTED_AT_STAGING" &&
          reviewStatus !== "DELIST_AT_PRODUCTION" &&
          reviewStatus !== "DELIST_AT_STAGING" &&
          reviewStatus !== "REJECTED_BY_DOMAIN_APPROVER" &&
          reviewStatus !== "DOMAIN_APPROVAL_IN_REVIEW" && (
            <Stack direction="row" alignItems="center" spacing={2}>
              {fileData === null && (
                <FileUploader
                  classes="fileContentClsUploadCreateNewRelease hide-file-types"
                  multiple={false}
                  handleChange={handleFileChange}
                  onTypeError={handleFileTypeError}
                  name="file"
                  types={fileTypes}
                  uploadedLabel="Uploaded Successfully!"
                  hoverTitle=""
                  dropMessageStyle={{ display: "none" }}
                >
                  <div
                    style={{
                      padding: "24px",
                      textAlign: "center",
                      color: "#121415",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <span style={{ color: "#0476E2" }}>Browse&nbsp;</span> or
                    Drag & drop the report file here
                  </div>
                </FileUploader>
              )}
              {fileData !== null && (
                <div className="fileName-popup-div">
                  <div className="filename-popup-text">{fileName}</div>
                  <button
                    type="button"
                    onClick={deleteFile}
                    style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }}
                    aria-label="Remove uploaded file"
                  >
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z"
                        stroke="#121415"
                        strokeOpacity="0.2"
                      />
                      <path
                        d="M15.5553 28C15.0664 28 14.6479 27.8259 14.2998 27.4778C13.9516 27.1296 13.7776 26.7111 13.7776 26.2222V14.6667H12.8887V12.8889H17.3331V12H22.6664V12.8889H27.1109V14.6667H26.222V26.2222C26.222 26.7111 26.0479 27.1296 25.6998 27.4778C25.3516 27.8259 24.9331 28 24.4442 28H15.5553ZM24.4442 14.6667H15.5553V26.2222H24.4442V14.6667ZM17.3331 24.4444H19.1109V16.4444H17.3331V24.4444ZM20.8887 24.4444H22.6664V16.4444H20.8887V24.4444Z"
                        fill="#121415"
                        fillOpacity="0.6"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </Stack>
          )}
        {reviewStatus !== "REJECTED_AT_PRODUCTION" &&
          reviewStatus !== "REJECTED_AT_STAGING" &&
          reviewStatus !== "DELIST_AT_PRODUCTION" &&
          reviewStatus !== "DELIST_AT_STAGING" &&
          reviewStatus !== "REJECTED_BY_DOMAIN_APPROVER" &&
          reviewStatus !== "DOMAIN_APPROVAL_IN_REVIEW" &&
          reviewStatus !== "reject_staging" &&
          reviewStatus !== "reject_production" &&
          getConfig().REACT_APP_PORTAL !== "global-admin" && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "15px",
              }}
            >
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: "#f0f0f0",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid #e0e0e0",
                }}
              >
                <svg
                  width="16"
                  height="10"
                  viewBox="0 0 16 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.26953 4.53516V4.93945C7.26953 5.58789 7.18164 6.16992 7.00586 6.68555C6.83008 7.20117 6.58203 7.64062 6.26172 8.00391C5.94141 8.36328 5.55859 8.63867 5.11328 8.83008C4.67188 9.02148 4.18164 9.11719 3.64258 9.11719C3.10742 9.11719 2.61719 9.02148 2.17188 8.83008C1.73047 8.63867 1.34766 8.36328 1.02344 8.00391C0.699219 7.64062 0.447266 7.20117 0.267578 6.68555C0.0917969 6.16992 0.00390625 5.58789 0.00390625 4.93945V4.53516C0.00390625 3.88281 0.0917969 3.30078 0.267578 2.78906C0.443359 2.27344 0.691406 1.83398 1.01172 1.4707C1.33594 1.10742 1.71875 0.830078 2.16016 0.638672C2.60547 0.447266 3.0957 0.351562 3.63086 0.351562C4.16992 0.351562 4.66016 0.447266 5.10156 0.638672C5.54688 0.830078 5.92969 1.10742 6.25 1.4707C6.57422 1.83398 6.82422 2.27344 7 2.78906C7.17969 3.30078 7.26953 3.88281 7.26953 4.53516ZM5.49414 4.93945V4.52344C5.49414 4.07031 5.45312 3.67188 5.37109 3.32812C5.28906 2.98438 5.16797 2.69531 5.00781 2.46094C4.84766 2.22656 4.65234 2.05078 4.42188 1.93359C4.19141 1.8125 3.92773 1.75195 3.63086 1.75195C3.33398 1.75195 3.07031 1.8125 2.83984 1.93359C2.61328 2.05078 2.41992 2.22656 2.25977 2.46094C2.10352 2.69531 1.98438 2.98438 1.90234 3.32812C1.82031 3.67188 1.7793 4.07031 1.7793 4.52344V4.93945C1.7793 5.38867 1.82031 5.78711 1.90234 6.13477C1.98438 6.47852 2.10547 6.76953 2.26562 7.00781C2.42578 7.24219 2.62109 7.41992 2.85156 7.54102C3.08203 7.66211 3.3457 7.72266 3.64258 7.72266C3.93945 7.72266 4.20312 7.66211 4.43359 7.54102C4.66406 7.41992 4.85742 7.24219 5.01367 7.00781C5.16992 6.76953 5.28906 6.47852 5.37109 6.13477C5.45312 5.78711 5.49414 5.38867 5.49414 4.93945ZM8.73516 0.46875H11.9168C12.5691 0.46875 13.1297 0.566406 13.5984 0.761719C14.0711 0.957031 14.4344 1.24609 14.6883 1.62891C14.9422 2.01172 15.0691 2.48242 15.0691 3.04102C15.0691 3.49805 14.991 3.89062 14.8348 4.21875C14.6824 4.54297 14.4656 4.81445 14.1844 5.0332C13.907 5.24805 13.5809 5.41992 13.2059 5.54883L12.6492 5.8418H9.88359L9.87187 4.4707H11.9285C12.2371 4.4707 12.493 4.41602 12.6961 4.30664C12.8992 4.19727 13.0516 4.04492 13.1531 3.84961C13.2586 3.6543 13.3113 3.42773 13.3113 3.16992C13.3113 2.89648 13.2605 2.66016 13.159 2.46094C13.0574 2.26172 12.9031 2.10938 12.6961 2.00391C12.4891 1.89844 12.2293 1.8457 11.9168 1.8457H10.493V9H8.73516V0.46875ZM13.5047 9L11.5594 5.19727L13.4168 5.18555L15.3855 8.91797V9H13.5047Z"
                    fill="black"
                    fillOpacity="0.3"
                  />
                </svg>
              </div>
            </div>
          )}
        {reviewStatus !== "REJECTED_AT_PRODUCTION" &&
          reviewStatus !== "REJECTED_AT_STAGING" &&
          reviewStatus !== "DELIST_AT_PRODUCTION" &&
          reviewStatus !== "DELIST_AT_STAGING" &&
          reviewStatus !== "reject_staging" &&
          reviewStatus !== "reject_production" &&
          reviewStatus !== "DOMAIN_APPROVAL_IN_REVIEW" &&
          reviewStatus !== "REJECTED_BY_DOMAIN_APPROVER" &&
          getConfig().REACT_APP_PORTAL !== "global-admin" && (
            <div>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "16px",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                  verticalAlign: "middle",
                  color: "#2A2C2D",
                  marginBottom: "10px",
                }}
              >
                Link to report
              </Typography>
              <TextField
                sx={{
                  "&.MuiFormControl-root": {
                    padding: "4px 8px 4px 0px",
                    height: "40px !important",
                  },
                  "&.MuiFormHelperText-root": {
                    letterSpacing: "0px !important",
                    fontSize: "10px !important",
                    marginLeft: "3px !important",
                  },
                  "&.Mui-error": {
                    letterSpacing: "0px !important",
                    fontSize: "10px !important",
                    marginLeft: "3px !important",
                  },
                }}
                label={!reportLink && "Paste Link"}
                slotProps={{
                  input: {
                    sx: {
                      "&.Mui-disabled": {
                        backgroundColor: "#F3F3F3 !important",
                        borderColor: "#1214151A",
                      },
                    },
                  },
                  formHelperText: {
                    sx: {
                      letterSpacing: "0px !important",
                      fontSize: "10px !important",
                      marginLeft: "3px !important",
                    },
                  },
                  inputLabel: {
                    shrink: false,
                    sx: {
                      fontSize: "12px",
                      fontWeight: 400,
                      lineHeight: "16.41px",
                      textAlign: "left",
                      color: "rgba(113, 114, 115, 1)",
                    },
                  },
                }}
                value={reportLink}
                defaultValue={reportLink}
                fullWidth
                onChange={($event) => handleReportLinkChange($event)}
                error={errorReportLink}
                onBlur={() => getReportUrl()}
                disabled={fileData !== null}
                helperText={
                  errorReportLink
                    ? 'Invalid URL format. Please enter a URL starting with "https://".'
                    : ""
                }
              />
            </div>
          )}
        {(reviewStatus === "DELIST_AT_PRODUCTION" ||
          reviewStatus === "DELIST_AT_STAGING") && (
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              lineHeight: "140%",
              letterSpacing: "0px",
              verticalAlign: "middle",
              color: "#5A5B5C",
              marginTop: "10px",
            }}
          >
            That action will remove the app from active distribution on all the
            head units and make it unaccessible for all the current users.
          </Typography>
        )}
        <div>
          <Typography
            sx={{
              paddingTop: errorReportLink ? "10px" : "14px",
              fontWeight: "600",
              marginBottom: "4px",
              fontSize: "16px",
              lineHeight: "100%",
              letterSpacing: "0px",
              verticalAlign: "middle",
              color: "#2A2C2D",
              marginTop:
                reviewStatus === "DELIST_AT_PRODUCTION" ||
                reviewStatus === "DELIST_AT_STAGING"
                  ? "10px"
                  : "0px",
            }}
          >
            {reviewStatus === "DELIST_AT_PRODUCTION" ||
            reviewStatus === "DELIST_AT_STAGING"
              ? "Reason"
              : "Comment"}{" "}
            {nextReviewStatus !== "approve_staging" &&
              nextReviewStatus !== "approve_production" &&
              nextReviewStatus !== "DOMAIN_APPROVAL_APPROVED" &&
              nextReviewStatus !== "reject_staging" &&
              nextReviewStatus !== "reject_production" && (
                <span style={{ color: "#B50B00" }}>*</span>
              )}
          </Typography>
          {!forceInstall && (
            <TextField
              sx={{
                "&.MuiFormControl-root": {
                  padding: "4px 8px 4px 0px",
                  height: "40px !important",
                },
                "&.MuiFormHelperText-root": {
                  letterSpacing: "0px !important",
                  fontSize: "10px !important",
                  marginLeft: "3px !important",
                },
                "&.Mui-error": {
                  letterSpacing: "0px !important",
                  fontSize: "10px !important",
                  marginLeft: "3px !important",
                },
              }}
              label={!reportComment && "Add the comment"}
              slotProps={{
                formHelperText: {
                  sx: {
                    letterSpacing: "0px !important",
                    fontSize: "10px !important",
                    marginLeft: "3px !important",
                  },
                },
                inputLabel: {
                  shrink: false,
                  sx: {
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "16.41px",
                    textAlign: "left",
                    color: "rgba(113, 114, 115, 1)",
                  },
                },
              }}
              value={reportComment}
              defaultValue={reportComment}
              fullWidth
              onChange={($event) => handleReportComment($event)}
            />
          )}
          {forceInstall && (
            <div style={{ marginTop: "10px" }}>
              <Select
                className="input-select-activity-log-select"
                sx={{
                  border: "none",
                  marginTop: "10px",
                  "& .MuiList-root": {
                    padding: "0px",
                  },
                  "& .MuiMenuItem-root": {
                    borderRadius: "4px",
                    "&:hover": {
                      backgroundColor: "#E5F3FF",
                      color: "#E5F3FF",
                      padding: "8px",
                    },
                  },
                }}
                defaultValue={forceUninstallReasonValue}
                value={forceUninstallReasonValue}
                fullWidth
                onChange={($event) => handleChangeReasonForceUninstall($event)}
                variant="outlined"
              >
                {listedReasons.map((item, index) => {
                  return (
                    <MenuItem
                      sx={{
                        padding: "8px !important",
                        fontSize: "12px",
                        "&.Mui-selected": {
                          backgroundColor: "#E5F3FF",
                          borderRadius: "4px",
                          color: "#0476E2",
                          fontWeight: "600",
                        },
                        "&.MuiMenuItem-root": {
                          marginLeft: "8px !important",
                          marginRight: "8px !important",
                        },
                        "&:hover": {
                          borderRadius: "4px",
                        },
                      }}
                      key={item}
                      value={index}
                    >
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>
          )}
        </div>
        { ((getConfig().REACT_APP_PORTAL === "oem-admin" &&
        (nextReviewStatus === "APPROVED_FOR_CLOSED_BETA" ||
          nextReviewStatus === "PRODUCTION_APPROVAL_APPROVED" ||
          nextReviewStatus === "STAGING_APPROVAL_APPROVED"
        ) && showDSACheckbox) || (getConfig().REACT_APP_PORTAL === "global-admin" &&
        nextReviewStatus === "approve_production" && europeanCountries)) &&
        <div className="dsa-section-in-popup">
          <Typography
            sx={{
              paddingTop: errorReportLink ? "10px" : "0px",
              fontWeight: "600",
              marginBottom: "10px",
              fontSize: "16px",
              lineHeight: "100%",
              letterSpacing: "0px",
              verticalAlign: "middle",
              color: "#2A2C2D",
              marginTop:
                reviewStatus === "DELIST_AT_PRODUCTION" ||
                reviewStatus === "DELIST_AT_STAGING"
                  ? "10px"
                  : "0px",
            }}
          >
            DSA Complaint
          </Typography>
          <div>
            <div>
            <div style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginLeft:"-10px"
                  }}>
            <Checkbox
              label="Default value"
              checked={dsaCompliant}
               onChange={($event) => setDsaCompliant($event.target.checked)}
              size="small"
            />
            <p className="dsa-popup-text-approve-for-production" style={{
              color: "#2A2C2D",
              fontWeight: 400,
              fontSize: "14px",
              margin: "0px",
              opacity: 0.8
            }}>
              <span>I confirm that the </span>
              <a
                style={{
                  color: "#0476E2",
                  fontSize: "14px",
                  fontWeight: "600",
                  letterSpacing: "0.15px",
                  textDecoration: "underline",
                }}
                target="_blank"
                className="digital-service-act-text"
                href="https://commission.europa.eu/strategy-and-policy/priorities-2019-2024/europe-fit-digital-age/digital-services-act_en"
              >
                Digital Service Act (DSA)
              </a>
              {" "}
              information provided by the developer has been reviewed.
            </p>
            </div>
            <div>
            <p className="dsa-popu-two-text-approve-for-production" style={{
              color: "#2A2C2D",
              fontWeight: 400,
              fontSize: "14px",
              marginTop: "8px",
              marginLeft:"28px",
              opacity: 0.8
            }}>
              <span
                style={{
                  fontWeight: 800,
                  fontSize: "14px",
                  letterSpacing: "0.15px",
                }}
              >
                Note:
              </span>{" "}
             The confirmation applies only to the review of the supplied DSA information
              and does not constitute a validation of an application's compliance status.
            </p>
            </div>
            </div>
          </div>
        </div>
       }
        {(reviewStatus === "DELIST_AT_PRODUCTION" ||
          reviewStatus === "DELIST_AT_STAGING") && (
          <div>
            <Checkbox
              label="Default value"
              checked={forceInstall}
              onChange={($event) => handleForceInstallAll($event)}
              size="small"
            />
            <span className="include-all">
              Force Unistall from the head units
            </span>
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            marginTop: "15px",
          }}
        >
          <Button className="cancelPopupButton" onClick={handlePopupModalClose}>
            Cancel
          </Button>

          <Button
            variant="outlined"
            sx={{
              "&.Mui-disabled": {
                color: "rgba(0, 0, 0, 0.26) !important",
                backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                border: "1px solid rgba(0, 0, 0, 0.12) !important",
              },
            }}
            onClick={sendApproveOrReject}
            className="savePopupButton"
            disabled={isSubmitting || (isNotActive && !forceInstall)}
          >
            {isSubmitting ? <CircularProgress size={20} /> : "Submit"}
          </Button>
        </div>
      </div>

      <PopupDialog
        openErrorPopup={openErrorPopup}
        errorMessage={errorMessage}
        headerMessage={headerMessage}
        componentName={componentName}
        onClose={() => setOpenErrorPopup(false)}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default ApproveApplicationPopUp;
